"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreePropertyOptionsOverlayContentModule = /** @class */ (function () {
    function TreePropertyOptionsOverlayContentModule() {
    }
    return TreePropertyOptionsOverlayContentModule;
}());
exports.TreePropertyOptionsOverlayContentModule = TreePropertyOptionsOverlayContentModule;
